module.exports = __webpack_public_path__ + "static/media/djhelperhome.9eac1431.png";